import { render } from "./Createcampaign.vue?vue&type=template&id=723e6ccc&scoped=true"
import script from "./Createcampaign.vue?vue&type=script&lang=js"
export * from "./Createcampaign.vue?vue&type=script&lang=js"

import "./Createcampaign.vue?vue&type=style&index=0&id=723e6ccc&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723e6ccc"]])

export default __exports__